import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const BASE = process.env.REACT_APP_BACKEND_URL;

export const LOCAL_BUSINESS_LD = {
  '@context': 'https://schema.org',
  '@type': 'Painter',
  name: 'Reverence Services',
  telephone: '+1-613-859-5893',
  email: 'experts@reverence.services',
  url: BASE,
  address: { '@type': 'PostalAddress', addressLocality: 'Orléans', addressRegion: 'ON', addressCountry: 'CA' },
  areaServed: ['Orléans', 'Ottawa', 'Barrhaven', 'Kanata', 'Nepean', 'Stittsville', 'Gatineau'],
  aggregateRating: { '@type': 'AggregateRating', ratingValue: '4.9', reviewCount: '20' },
  priceRange: '$$',
};

export const breadcrumbLd = (items) => ({
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: items.map((name, i) => ({
    '@type': 'ListItem',
    position: i + 1,
    name,
    item: `${BASE}${items.slice(0, i + 1).map((s) => s.toLowerCase().replace(/ /g, '-')).join('/')}`,
  })),
});

export default function Seo({ title, description, jsonLd = [] }) {
  const { pathname } = useLocation();
  useEffect(() => {
    document.title = title;
    const meta = document.querySelector('meta[name="description"]');
    if (meta) meta.setAttribute('content', description);
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.rel = 'canonical';
      document.head.appendChild(canonical);
    }
    canonical.href = `${BASE}${pathname}`;
    const scripts = jsonLd.map((data) => {
      const s = document.createElement('script');
      s.type = 'application/ld+json';
      s.text = JSON.stringify(data);
      document.head.appendChild(s);
      return s;
    });
    return () => scripts.forEach((s) => s.remove());
  }, [title, description, pathname, jsonLd]);
  return null;
}
